import { Modal as MuiModal, Paper } from "@mui/material";


const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 428,
  overflowY: 'auto',
  maxHeight: '90vh',
  // bgcolor: "var(--background-modal-color)",
  boxShadow: 24,
  // p: "var(--padding-base)",
  borderRadius: "12px",
  outline: "none",
  // padding: '32px',
};

function Modal(props) {
  const {
    custombg,
    width,
    bordered,
    paperSx,
    children,
    slotProps,
    ...muiModalProps
  } = props;

  const paperStyle = { ...modalStyle };
  // 指定modal背景色 用于第三方不可控内容 同时padding设为0
  if (custombg) {
    paperStyle.bgcolor = custombg;
    paperStyle.p = '0';
  }
  if (width) {
    paperStyle.width = width;
  }

  return (
    <MuiModal slotProps={slotProps} {...muiModalProps}>
      <Paper elevation={0} sx={theme => {
        const customPaperSx = typeof paperSx === 'function' ? paperSx(theme) : paperSx;
        return {
          ...paperStyle,
          ...(bordered && {
            border: `1px solid ${
              theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.2)'
                : 'rgba(16, 5, 28, 0.1)'
            }`,
          }),
          ...customPaperSx,
        };
      }}>
        {children}
      </Paper>
    </MuiModal>
  );
}

export default Modal;
export { Modal };

